export default "__VITE_ASSET__JR$rZGp9__"